import { useCallback } from 'react'

import { useQueueStatsFilterQuery } from 'modules/Monitoring/api/analytics/queries'
import { useChannel } from 'modules/Monitoring/hooks/useChannel'
import { VolumeAggregationDimensionExtended } from 'modules/Monitoring/types'

import { aggregationDimensionOptionsMap } from '../consts'

export const useVerifyChannelAndDimensionCoherence = () => {
  const { channel } = useChannel()
  const { data: additionalFilters, isPending } = useQueueStatsFilterQuery({
    channel,
  })

  return useCallback(
    (dimension: VolumeAggregationDimensionExtended, dimensionTarget?: string) => {
      if (!channel) {
        return false
      }

      return aggregationDimensionOptionsMap[channel].some(option => {
        if (option.value === dimension) {
          return true
        }

        if (option.filterChildKey === dimension) {
          if (isPending || !dimensionTarget) {
            return true
          }
          if (!additionalFilters) {
            return false
          }

          return additionalFilters.items.some(
            filter =>
              filter.key === option.filterKey &&
              filter.values.some(filterValue => filterValue.id === dimensionTarget),
          )
        }

        return false
      })
    },
    [channel, isPending, additionalFilters],
  )
}
